import { styled } from "@mui/material";
import { Icons } from "..";

export const DatePickerCaretLeft = styled(Icons.CaretLeft)(({ theme }) =>
    theme.unstable_sx({
        width: "2rem",
        height: "2rem",
    }),
);

export const DatePickerCaretRight = styled(Icons.CaretRight)(({ theme }) =>
    theme.unstable_sx({
        width: "2rem",
        height: "2rem",
    }),
);

export const DatePickerCalendarIcon = styled(Icons.Calendar)(({ theme }) =>
    theme.unstable_sx({
        width: "2.4rem",
        height: "2.4rem",
        color: "primary.main",
    }),
);

export const DatePickerSwitchViewIcon = styled(Icons.Contracts)(({ theme }) =>
    theme.unstable_sx({
        width: "2rem",
        height: "2rem",
    }),
);
